import React,{useRef, useState, useEffect, Component} from "react";
import ReactDOM			from "react-dom";
import LayerTablePanel	from "../components/LayerTablePanel";
import { 
	Select, 
	Form, 
	Row, 
	Col, 
	Dropdown 
}							from "react-bootstrap";
import EditNow				from "../components/EditNow";
import DialogLayerLibrary	from "../layouts/DialogLayerLibrary";
import DialogUploadLayer	from "../layouts/DialogUploadLayer";
import DialogBuffer			from "../layouts/DialogBuffer";
import { DndProvider }		from "react-dnd";
import atlasApi				from "../utils/atlasapi";
import JSZip from 'jszip';
import fs					from 'file-saver';
import {filenamify}			from "../utils/functions";
import { 
	PencilSimple, 
	Folder, 
	FolderOpen, 
	DotsSixVertical, 
	CircleHalf, 
	Palette, 
	Trash, 
	DownloadSimple,
	Crosshair, 
	PlusCircle, 
	FolderSimplePlus, 
	UploadSimple, 
	StackSimple, 
	Table, 
	Book  
}							from "@phosphor-icons/react";
import wmConfig				from "../data/wmConfig";
import globalContext		from "../utils/globalContext";
import {
	Tree,
	NodeModel,
	MultiBackend,
	getBackendOptions,
	useDragOver
}							from "@minoru/react-dnd-treeview";
import { 
	useContextMenu, 
	contextMenu, 
	Menu, 
	Item 
}							from 'react-contexify';

import {baseMaps}			from "../data/baseMaps";
import LayerStylePanel		from "../components/LayerStylePanel";
import LayerCable			from "../classes/LayerCable";
import LayerBoundary		from "../classes/LayerBoundary";
import LayerRoad			from "../classes/LayerRoad";
import LayerEllipses		from "../classes/LayerEllipses";
import LayerTurbine			from "../classes/LayerTurbine";
import LayerExclusion		from "../classes/LayerExclusion";
import LayerDrawing			from "../classes/LayerDrawing";
import LayerSensor			from "../classes/LayerSensor";
import LayerAnnotation		from "../classes/LayerAnnotation";
import LayerSubstations		from "../classes/LayerSubstations";
import LayerProperties		from "../classes/LayerProperties";
import LayerGates			from "../classes/LayerGates";
import ToolTurbine			from "../classes/ToolTurbine";
import {
	getTilesUrl,
	getTilesApiKey,
	getCogApiKey
}							from "../utils/tilesConfig";

// URL and key are fetched by AuthGate from the authenticated
// /config/tileserver/ endpoint — never from the build env.
const getSourceUrl			= (table, scenarioId)				=> `${getTilesUrl()}/${table}/{z}/{x}/{y}?apikey=${getTilesApiKey()}&scenarioId=${scenarioId}`;

/* Flisnøkkelen til COG-serveren (/v3/tiles/...) hører til økten, ikke til
   laget. Den tas ut før et scenario lagres og settes inn igjen ved innlasting,
   slik at et gammelt scenario ikke sitter igjen med en rotert nøkkel.
   Andre rasterlag — WMS og liknende — er ikke våre og røres ikke. */
const erCogFlis				= (url)								=> typeof url === 'string' && url.includes('/v3/tiles/');
const withoutCogToken		= (url)								=> erCogFlis(url) ? url.replace(/([?&])token=[^&]*/, '$1token=') : url;
const withCogToken			= (url)								=> erCogFlis(url) ? withoutCogToken(url).replace(/([?&])token=/, `$1token=${encodeURIComponent(getCogApiKey())}`) : url;


const isActive = (element) => element.defaultChecked;

/* Fargen som representerer laget i hoeyreklikk-popupen. Er fargen satt som en
   dataregel ('case', ...), finnes det ingen enkelt farge — da brukes siste
   ledd, som er standardverdien i uttrykket. */
const layerSwatchColor = (layers) => {
	for(const l of layers){
		const paint = l.paint || {};
		const value = paint[l.type+'-color'] || paint['fill-color'] || paint['line-color'] || paint['circle-color'];

		if(typeof value === 'string')
			return value;

		if(Array.isArray(value)){
			const last = value[value.length-1];
			if(typeof last === 'string')
				return last;
		}
	}
	return '#8a8f98';
}

/* Feltet lagets etikett tegnes fra, om det finnes. Popupen bruker det samme
   feltet som tittel paa objektet, slik at raden i popupen heter det samme som
   teksten i kartet. */
/* Filtrene fra attributtabellen oversatt til et Mapbox-uttrykk, slik at
   objektene som faller utenfor ogsaa forsvinner fra kartet.

   Tallkolonner maa gjennom to-number: flisene lagrer verdien med sin egen type,
   og en tekstsammenlikning ville gjort 9 > 100 sant. Typene kommer fra
   API-svaret, som leser dem av information_schema. */
const NUMERISKE_TYPER = new Set(['smallint', 'integer', 'bigint', 'decimal', 'numeric', 'real', 'double precision']);

const MAPBOX_OPS = {'=': '==', '≠': '!=', '!=': '!=', '>': '>', '<': '<'};

const layerFilterExpression = (filters, columns) => {

	const typer = {};
	(columns || []).forEach((c)=>{typer[c.name] = c.type;});

	const ledd = filters.map((f)=>{

		const tall	= NUMERISKE_TYPER.has(typer[f.field]);
		const felt	= tall ? ['to-number', ['get', f.field]] : ['to-string', ['get', f.field]];
		const verdi	= tall ? Number(f.value) : String(f.value);

		return [MAPBOX_OPS[f.op] || '==', felt, verdi];
	});

	return ['all', ...ledd];
}

const layerLabelField = (layers) => {
	for(const l of layers){
		const field = l.layout && l.layout['text-field'];
		if(Array.isArray(field) && field[0] === 'get' && typeof field[1] === 'string')
			return field[1];
	}
	return null;
}



const sort = (array)=>{
	
	var result = array.filter((i)=>!i.parent);
	
	array.reverse();
	
	array.forEach((i)=>{
		if(!i.parent)
			return;
		var idx =  result.findIndex((s)=>i.parent==s.id);
		if(idx>-1){
			result.splice(idx+1, 0, i);
		}
		else
			result.push(i);
	});
	
	return result;
	
}


class InfoLayers extends Component {

	static contextType = globalContext;
	
	images = [];
	layerTools = {};
	
	constructor(props) {
		
		super(props);
		if(this.props.map)
			this.map = this.props.map.current ? this.props.map.current : this.props.map;
		this.layerStylePanel = React.createRef();
		this.libraryDialog = React.createRef();
		
		this.ctx = this.props.context;

		//sync layer names
		this.sanitizeLayers();
		
		const layers = this.compileLayers();
		
		
		
		this.state = {
			contextLayer: null,
			items: layers,
			selectedItems: [],
			dialog: {open:false},	
			dialogUpload: {open:false},	
			dialogBuffer: {open:false},	
			tablePanel: null,
		};
		
		this.redraw();
	}
	componentDidMount(){
		//this.stackProjectLayer();
	}

	componentDidUpdate(prevProps, prevState) {
		var self = this;
		
		
		if(prevProps.scenario.scenario_id != this.props.scenario.scenario_id){
			this.undraw(prevState);
			this.sanitizeLayers();
			this.setState({...this.state, ...{items:this.compileLayers()}}, ()=>{
				self.redraw();
				
			});
			
			
			
		}
	}
	compileLayers = ()=>{

		return [
			...this.boundaryLayer(), 
			...this.turbinesLayer(),
			...this.ellipsesLayer(),
			...this.powerLineLayer(), 
			...this.roadsLayer(), 
			...this.propertiesLayer(), 
			...this.exclusionsLayer(), 
			...this.drawingsLayer(), 
			...this.sensorsLayer(), 
			...this.substationsLayer(),
			...this.gatesLayer(),
			...this.annotationsLayer(),
			...this.props.scenario.layers,
		];
	}
	boundaryLayer(){
		
		const lId = 'boundary';
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
		
		const layerObj = (new LayerBoundary(this.ctx.tc.draw, this.ctx.tc.scenario, this.ctx.tc)).json();
		
		layerObj.fn = 'boundaryLayer';
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Boundary"
		};
		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}
			
			return [];
		}
		l.data = {...l.data, ...layerObj};
		return [l];
		
	}
	propertiesLayer(){
		const exists = this.findIdx('properties', this.props.scenario.layers)
		const existsTree = this.state ? this.findIdx('properties') : false;
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const layerObj = (new LayerProperties(this.ctx.tc.draw, this.ctx.tc.scenario, this.ctx.tc)).json();
		
		// Som de oevrige systemlagene: fn gjoer at resetSystemLayer bygger
		// definisjonen paa nytt. Uten den ble den lagrede definisjonen vist
		// igjen, og den ble laget ved montering da map.projectLayer fortsatt
		// var 'owners' -- saa et statusbytte slo kartet tilbake til eierfarger.
		layerObj.fn = 'propertiesLayer';
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: "properties"
			},
			id: "properties",
			parent: 0,
			text: "Properties"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}
		if(exists !== false){
			this.props.scenario.layers[exists].data = {...this.props.scenario.layers[exists].data, ...layerObj}
			return [];
		}
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	powerLineLayer(){
		if(!this.ctx.tc.scenario)
			return [];
		const lId = 'powerlines';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerCable(this.ctx.tc.draw, this.ctx.tc.scenario, this.ctx.tc)).json();
		
		layerObj.fn = 'powerLineLayer';
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Powerlines"
		};
		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}
			
			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	
	roadsLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'roads';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerRoad(this.ctx)).json();
		
		layerObj.fn = 'roadsLayer';
			
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Roads"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}
			
			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	
	}
	ellipsesLayer(){
		if(!this.ctx.tc.scenario)
			return [];
		
		
		const lId = 'ellipses';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerEllipses(this.ctx)).json();
		
		layerObj.fn = 'ellipsesLayer';
			
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Ellipses"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}
			
			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	turbinesLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'turbines';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerTurbine(this.ctx)).json();
		
		layerObj.fn = 'turbinesLayer';
		this.layerTools[lId] = ToolTurbine;
		
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Turbines"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	sensorsLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'sensors';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerSensor(this.ctx)).json();
		
		layerObj.fn = 'sensorsLayer';
		
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Sensors"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	substationsLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'substations';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerSubstations(this.ctx)).json();
		
		layerObj.fn = 'substationsLayer';
		
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Substations"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	gatesLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'gates';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerGates(this.ctx)).json();
		
		layerObj.fn = 'gatesLayer';
		
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Gates"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	annotationsLayer(){
		
		if(!this.ctx.tc.scenario)
			return [];
		
		const lId = 'annotations';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerAnnotation(this.ctx)).json();
		
		layerObj.fn = 'annotationsLayer';
		
		this.addImages(layerObj);
		
		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Annotations"
		};

		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	
	exclusionsLayer(){
		if(!this.ctx.tc.scenario)
			return [];
		const lId = 'exclusions';
		
		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;
	
		const layerObj = (new LayerExclusion(this.ctx.tc.draw, this.ctx.tc.scenario, this.ctx.tc)).json();
		
		layerObj.fn = 'exclusionsLayer';

		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Exclusions"
		};
		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}	
		if(existsScenario !== false){
			
			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}
			
			return [];
		}
		
		l.data = {...l.data, ...layerObj};
		return [l];
	}
	
	drawingsLayer(){
		if(!this.ctx.tc.scenario)
			return [];
		const lId = 'drawings';

		const existsScenario = this.findIdx(lId, this.props.scenario.layers);
		const existsTree = this.state ? this.findIdx(lId) : false;

		const layerObj = (new LayerDrawing(this.ctx.tc.draw, this.ctx.tc.scenario, this.ctx.tc)).json();

		layerObj.fn = 'drawingsLayer';

		const l = {
			data:{
				defaultChecked: true,
				vindrid: 0,
				passive:true,
				id: lId
			},
			id: lId,
			parent: 0,
			text: "Drawings"
		};
		if(existsTree !== false){
			this.state.items[existsTree].data = {...this.state.items[existsTree].data, ...layerObj}
		}
		if(existsScenario !== false){

			this.props.scenario.layers[existsScenario].data = {...this.props.scenario.layers[existsScenario].data, ...layerObj}

			return [];
		}

		l.data = {...l.data, ...layerObj};
		return [l];
	}
	
	getTool(item){
	   if(!this.layerTools[item.id])
		   return false;
	   return new (this.layerTools[item.id])(this.ctx.tc, true);
	}
	toolMenu(item){
		const tool = this.getTool(item);
		if(!tool)
			return false;
		return tool.layerPanelMenu();
	}
	resetSystemLayer(id){
		var idx = this.findIdx(id);
		
		if(idx !== false){
			
			this.hideInfoLayer(this.state.items[idx].data);
			
			if(this.state.items[idx].data.fn)
				this[this.state.items[idx].data.fn]();
			
			const topLayer = this.findClosestActiveLayer(this.state.items, {dragSourceId:id, dropTargetId:this.state.items[idx].parent});
			
			this.showInfoLayer(this.state.items[idx].data, topLayer);
			
			
		}
		
	}
	updateLayerData(id){
		var idx = this.findIdx(id);
		
		if(idx != -1 && this.state.items[idx].data.fn)
			this[this.state.items[idx].data.fn]();
	}
	
	addImages(layerObj){
		
		if(!Array.isArray(layerObj.images))
			return;
		
		layerObj.images.forEach((i)=>{
			if(!this.images.find((im)=>{return im.name == i.name}))
				this.images.push(i);
		});
		
		
	}
	
	getTurbineRelatedLayers(){
		return this.props.du.getTurbineRelatedLayerIds().map((id)=>{return {id:id}});
	}
	
	
	sanitizeLayers(){
		
		//sync layer names
		if(this.props.scenario && Array.isArray(this.props.scenario.layers)){
			//comented because at this time the user is still not loaded, and there is no layer set
//			this.props.scenario.layerLibrary.forEach((i)=>{
//				var idx = this.props.scenario.layers.findIndex((l)=>{
//					return l.vindrId == i.id;
//				});
//				if(idx > -1){
//					this.props.scenario.layers[idx].text = i.name;
//				}
//			});
		}
		else
			this.props.scenario.layers = [];
		
		
		this.props.scenario.layers.forEach((i)=>{
			if(i.data.source && i.data.source.type == 'vector' && i.data.source.tiles[0].substring(0,4).toUpperCase() != 'HTTP')
				i.data.source.tiles = [getSourceUrl(i.data.source.tiles[0], this.props.scenario.scenario_id)];

			/* COG-lagene lagres uten flisnøkkel (se updateStatus). Den settes
			   inn igjen her, med verdien som gjelder nå — et scenario lagret
			   før en nøkkelrotasjon skal ikke stå igjen med en død URL. */
			if(i.data.source && i.data.source.type == 'raster' && Array.isArray(i.data.source.tiles))
				i.data.source.tiles = [withCogToken(i.data.source.tiles[0])];
		});
		
	}
	updateStatus(s, callBack){
		var self = this;
		var tm = {};
		if(s.items){
			//console.log(s.items);
			
			if(this.state.saveDelay)
				clearTimeout(this.state.saveDelay);
			tm = {
				saveDelay : setTimeout(()=>{
					
					
					var payload = JSON.parse(JSON.stringify(s.items));
					
					payload.forEach((i)=>{
						if(i.data.source && i.data.source.type == 'vector'){
							i.data.source.tiles = [i.data.tablename ? i.data.tablename : i.data.id.split("-").slice(0, -1).join("-")];
						}

						/* Flisnøkkelen skal ikke fryses ned i et lagret scenario.
						   Uten dette peker laget på den nøkkelen som gjaldt den
						   dagen scenarioet ble lagret, og blir liggende død etter
						   en rotasjon. sanitizeLayers setter den inn igjen. */
						if(i.data.source && i.data.source.type == 'raster' && Array.isArray(i.data.source.tiles)){
							i.data.source.tiles = [withoutCogToken(i.data.source.tiles[0])];
						}
						
						if(['turbines', 'powerlines', 'sensors', 'roads', 'ellipses', 'properties', 'boundary', 'drawings', 'annotations', 'sensors'].includes(i.id)){
							delete i.data.source;
							delete i.data.layer;
							delete i.data.tool;
						}
					});
					if(this.props.onChange)
						this.props.onChange(payload);
					
					self.updateStatus({saveDelay:false})
				},300)
			}
			
		}
		
		var x = {...this.state, ...s, ...tm};
		//console.log(x);
		
		this.setState(x, callBack ? callBack : null);
		
		
	}
	handleSelect(node){
		
		var current = this.state.selectedItems.slice(0);
		
		const item = current.find((n) => n.id === node.id);

		if (!item) {
			this.updateStatus({selectedItems:[...current, node]});
		} 
		else {
			this.updateStatus({selectedItems:current.filter((n) => n.id !== node.id)});
		}
		
	}
	handleFolderToggle(nodeId){
		
		var items = this.get();
		
		var idx = this.findIdx(nodeId, items);
		
		items[idx].data.defaultOpen = !items[idx].data.defaultOpen;
		
		this.updateStatus({items:items});
		
	}
	handleOpacityChange(opacity){
		//this.state.contextLayer has the current right clicked layer
		
		//update opacity in tree object
		var items = this.get();
		var idx = this.findIdx(this.state.contextLayer.id, items);
		items[idx].data.opacity = opacity;
		this.updateStatus({items:items, contextLayer:items[idx]});
		if(Array.isArray(items[idx].data.layer)){
			items[idx].data.layer.forEach((l)=>{
				this.setLayerOpacity(l.id, opacity);
			});
			
		}
		else
			this.setLayerOpacity(items[idx].data.id, opacity);
		
	}
	setLayerOpacity(l, opacity){
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = this.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				
				var symOpI = opc;
				var symOpT = opc;
				
				var currT = this.map.getPaintProperty(l, 'text-opacity');
				//if layer has conditional opacity, preserve
				if(currT && Array.isArray(currT)){
					currT[currT.length-1] = opc;
					symOpT = currT;
				}
				
				var currI = this.map.getPaintProperty(l, 'icon-opacity');
				//if layer has conditional opacity, preserve
				if(currI && Array.isArray(currI)){
					currI[currI.length-1] = opc;
					symOpI = currI;
				}
				
				this.map.setPaintProperty(l, 'icon-opacity', symOpI);
				this.map.setPaintProperty(l, 'text-opacity', symOpT);
			}
			else if(layer.type === 'raster') {
				this.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				var op = ['case',
					['boolean', ['feature-state', 'invisible'], false],0,
					opc
				];
				this.map.setPaintProperty(l, layer.type+'-opacity', op);
			}
		}
	}
	handlePaintChange(val, type){
		var items = this.get();
		var idx = this.findIdx(this.state.contextLayer.id, items);
		
		var layerObj = Array.isArray(items[idx].data.layer) ? items[idx].data.layer : [items[idx].data.layer];
		
		//for this type we create another layer just for the line
		if(type.substring(0, 12) == 'fill-outline'){
			
			layerObj.forEach((l)=>{
				if(l.type == 'fill'){
					
					type = type.replace("fill-outline", "line");
					
					var hasOutline = layerObj.findIndex((o)=>{return o.id == l.id+"_outline"})
					
					//create outline layer and add it to stack and map
					if(hasOutline == -1){
						var copyForOutline = JSON.parse(JSON.stringify(l));
						delete copyForOutline.paint["fill-color"];
						delete copyForOutline.paint["fill-outline-color"];
						copyForOutline.type = 'line'
						copyForOutline.id += '_outline';
						copyForOutline.paint[type] = val;
						if(copyForOutline.paint["fill-opacity"]){
							copyForOutline.paint['line-opacity'] = copyForOutline.paint["fill-opacity"];
							delete copyForOutline.paint["fill-opacity"];
						}
						
						layerObj.push(copyForOutline);
						this.map.addLayer(copyForOutline);
					}
				}
				else{
					//outline layer already exists, style it as normal
					l.paint[type] = val;
					this.map.setPaintProperty(l.id, type, val);
				}
			})
			
			
		}
		else {
			layerObj.forEach((l)=>{
				//ignore outline layers in normal operations
				if(!l.id.includes('_outline')){
					this.map.setPaintProperty(l.id, type, val);
					l.paint[type] = val;
				}
			});
		}
		
		this.updateStatus({items:items, contextLayer:items[idx]});
	}
	getFolderInfo(id, res){
		
		var idx = this.findIdx(id, res);
		
		var children = res.filter((i)=>{return i.parent == id});
		
		var activeChildren = children.filter((i)=>{return i.data.defaultChecked || i.data.passive});
		
		return {
			idx: idx,
			children:children,
			activeChildren:activeChildren
		}
		
	}
	getLayerColor(node){

		var layerObj = Array.isArray(node.data.layer) ? node.data.layer[0] : node.data.layer;
		
		switch(layerObj.type){
			case 'fill':
				return layerObj.paint['fill-color'];
			case 'line':
				return layerObj.paint['line-color'];
			case 'circle':
				return layerObj.paint['circle-color'];
			///other cases symbol, circle etc
			
			
		}
	}
	reorderLayer(res, info){
		
		res = sort(JSON.parse(JSON.stringify(res)));
		
		//no sub folders allowed
		if(info.dragSource.droppable && info.dropTargetId)
			return;
		
		this.updateStatus({items:res});
		
		//if layer is not on, there is no reorder needed
		
		//inactive layer, don't care
		if(info.dragSource.data.layer && !info.dragSource.data.defaultChecked)
			return;
		
		//is folder, get folder info
		if(info.dragSource.droppable){
			this.getFolderInfo(info.dragSource.id, res);
		}

		const topLayer = this.findClosestActiveLayer(res, info);
		
		//reorder single layer 
		if(!info.dragSource.droppable){
			var layersToMove = info.dragSource.data.layer;
			if(!Array.isArray(info.dragSource.data.layer))
				layersToMove = [info.dragSource.data.layer];
			
			//layersToMove.reverse();
		}
		//reorder folder
		else {
			const folder = this.getFolderInfo(info.dragSource.id, res);
			var layersToMove = [];
			folder.activeChildren.forEach((l)=>{
				var layerIds = false;
				
				if(l.data.layerFn)
					layerIds = this[l.data.layerFn]();
				else 
					layerIds = (!Array.isArray(l.data.layer) ? [l.data.layer] : l.data.layer);
				
				layersToMove = [...layersToMove, ...layerIds];
			});
			
		}
		
		var last = topLayer;
		layersToMove.forEach((l)=>{
			this.stackLayer(l.id, last);
			last = l.id
		});			
		
	}
	stackLayer(layerId, layerAbove){
		

		this.map.moveLayer(layerId, layerAbove);	
		
		//this.stackProjectLayer();
			
	}
	stackProjectLayer(){
		if(this.map.getLayer('gl-draw-polygon-fill-inactive.cold')){
			['project-geojson-fill', 'project-geojson-stroke'].forEach((l)=>{
				this.map.moveLayer(l, 'gl-draw-polygon-fill-inactive.cold');
			});
		}
	}
	/* Lagene hoeyreklikk-popupen leser objekter fra.

	   Bare biblioteklagene: de har en egen vektorkilde, og attributtene deres er
	   kolonnene i datasettet brukeren lastet opp. Systemlagene (turbiner, veier,
	   kabler, grense, eksklusjoner) er markert passive, har egne verktoey og
	   paneler, og attributtene deres er interne felter — de holdes utenfor.
	   Rasterlag har ingen objekter i det hele tatt. */
	getQueryableLayers(){

		return this.state.items.filter((item)=>{

			const d = item.data;

			return d && !d.passive && d.defaultChecked && d.source && d.source.type === 'vector' && d.layer;

		}).map((item)=>{

			const layers = Array.isArray(item.data.layer) ? item.data.layer : [item.data.layer];

			return {
				id: item.data.id,
				name: item.text,
				color: layerSwatchColor(layers),
				labelField: layerLabelField(layers),
				layerIds: layers.map((l)=>l.id)
			};
		});
	}
	forceVisibility(id, state=true){
		
		var idx = this.findIdx(id);
		if(idx ===false)
			return false;
		
		const items = this.state.items;
		
		var target = items[idx];
		
		if(target.data.defaultChecked == state)
			return;
		
		//find the closest visible layer before this one
		
		document.getElementById("checkbox_"+target.data.id).checked = state;
		target.data.defaultChecked = state;
		
		if(state){
			const topLayer = this.findClosestActiveLayer(items, {dragSourceId:id, dropTargetId:items[idx].parent});
			this.showInfoLayer(target.data, topLayer);
		}
		else{
			this.hideInfoLayer(target.data);
		}
		
		
		
		this.updateStatus({items:items});
	}
	onLayerToggle(e, id){
		e.stopPropagation();

		var idx = this.findIdx(id);
		if(idx ===false)
			return false;

		const items = this.state.items;

		var target = items[idx];




		//find the closest visible layer before this one

		const topLayer = this.findClosestActiveLayer(items, {dragSourceId:id, dropTargetId:items[idx].parent});

		//	this.props.toggleInfoLayer(e);
		if(e.target.checked){
			target.data.defaultChecked = true;
			this.showInfoLayer(target.data, topLayer);
		}
		else {
			target.data.defaultChecked = false;
			this.hideInfoLayer(target.data);
		}
		this.updateStatus({items:items});

		this.map.fire('layer.toggle', { layerId: target.data.id, visible: e.target.checked });
	}
	onOpacity(e, node){
		//this.props.showOpacityControl(e);
		
		
		this.updateStatus({contextLayer:node}, ()=>{

			contextMenu.show({id:'layer_style_control', event:e, position: {
				x: 320,
				y: 100,
			}});			
		});
	}
	
	showInfoLayer(show, topLayer){
		var lastId;
		if(!show || !show.id) 
			return;
		
		if(show.passive && (!show.layer || !show.source)){
			
			if(show.layer){
				show.layer.forEach((l)=>{
					this.setLayerOpacity(l.id, typeof show.opacity !== 'undefined' ? show.opacity : 1);
				});
			}
			
			lastId = this.toggleVisibility(show, true, topLayer);
			
			return lastId;
		}
		
		if(show.source && show.source.type){
			
			/* when adding exisgint layer updates to more recent version*/ 
			if(show.vindrid === 0 && this.map.getSource(show.source.id))
				this.hideInfoLayer(show);
			
			if(!this.map.getSource(show.source.id)){
				//adding a geojson source with id, fails
				const s = structuredClone(show.source);
				delete s.id;
				this.map.addSource(show.source.id, s	);
			}
			var layersToAdd = show.layer;
			if(!Array.isArray(show.layer))
				layersToAdd = [show.layer];


			layersToAdd.forEach((l)=>{
				//set the opacity if there is a preset
				if(!this.map.getLayer(l.id)){
					
					//cleanup 
					if(l.type == 'line' && l.paint["fill-opacity"]){
						delete l.paint["fill-opacity"];
					}
					
					
					this.map.addLayer(l);
				}
				if(!l.paint || !l.paint[l.type+'-opacity'] || (show.opacity && show.opacity != l.paint[l.type+'-opacity']))
					this.setLayerOpacity(l.id, typeof show.opacity !== 'undefined' ? show.opacity : 1);
				lastId = l.id;
				this.stackLayer(l.id, topLayer);
			});			
		}
		
		/* 3d always on top */
		if(this.map.getLayer("3d-turbines"))
			this.map.moveLayer("3d-turbines");
		
		return lastId;
	}
	hideInfoLayer(hide){
		
		if(!hide || !hide.id) 
			return;

		if(hide.passive && (!hide.layer || !hide.source)){
			return this.toggleVisibility(hide, false);
		}
		var layersToHide = hide.layer;
		if(!Array.isArray(hide.layer))
			layersToHide = [hide.layer];


		layersToHide.forEach((l)=>{
			//set the opacity if there is a preset
			if(this.map.getLayer(l.id))
				this.map.removeLayer(l.id);
		});		
		if(hide.source && this.map.getSource(hide.source.id))
			this.map.removeSource(hide.source.id);
		
	}
	toggleVisibility(layerData, show, topLayer){
		
		if(!layerData.layer && !layerData.layerFn)
			return;
		this.props.du.draw.changeMode("simple_select");
		var last = topLayer;
		if(layerData.layer) {
			layerData.layer.forEach((l)=>{
				if(this.map.getLayer(l.id)){
					this.map.setLayoutProperty(
						l.id,
						'visibility',
						(show ? 'visible' : 'none')
					);
					this.stackLayer(l.id, last);
					last = l.id;
				}
			});
		}
		if(layerData.layerFn) {
			this[layerData.layerFn]().forEach((l)=>{
				last = l.id;
				this.map.setLayoutProperty(
					l.id,
					'visibility',
					(show ? 'visible' : 'none')
				);
			});
		}
		this.map.layerStatus[layerData.id] = show;
		return last;
	}
	deleteSelected(){
		
		var items = this.get();
		var removing = [];
		this.state.selectedItems.forEach((i)=>{
			
			if(!i.droppable)
				removing = [...removing, ...[this.findIdx(i.id)]]
			else {
				const childs = (items.filter((l)=>l.parent == i.id)).map((c)=>this.findIdx(c.id));
				removing = [...removing, ...[this.findIdx(i.id)], ...childs]
			}
		});
		
		removing.forEach((idx)=>{
			if(idx === false)
				return;
			if(items[idx].data.defaultChecked){
				this.hideInfoLayer(items[idx].data);
			}
		});
		items = items.filter((a, index)=>!removing.includes(index));
		this.updateStatus({items:items, selectedItems:[]});
	}
	deleteItem(i){
		
		var items = this.get();
		var removing = [];

		if(!i.droppable)
			removing = [this.findIdx(i.id)];
		else {
			const childs = (items.filter((l)=>l.parent == i.id)).map((c)=>this.findIdx(c.id));
			removing = [...[this.findIdx(i.id)], ...childs]
		}
	
		
		removing.forEach((idx)=>{
			if(idx === false)
				return;
			if(items[idx].data.defaultChecked){
				this.hideInfoLayer(items[idx].data);
			}
		});
		items = items.filter((a, index)=>!removing.includes(index));
		this.updateStatus({items:items, selectedItems:[]});
		//this.libraryDialog.current.remInUse(i.data);
	}
	
	redraw(){
		var lastId;
		if(!this.map)
			return;
		
		let map = this.map;
		
			
		this.state.items.forEach((item)=>{
			if(item.data.fn && typeof this[item.data.fn] === 'function'){
				this[item.data.fn]();
			}
		});

		Promise.all(
			this.images.map(img => new Promise((resolve, reject) => {
				if(this.map.hasImage(img.name)){
					resolve();
					return;
				}
			
				this.map.loadImage(img.src, function (error, res) {
					if(!map.hasImage(img.name))
						map.addImage(img.name, res);
					resolve();
				})
			}))
		)
		.then(()=>{
			if(this.map.currentBasemap && baseMaps[this.map.currentBasemap]?.layer)
					this.showInfoLayer(baseMaps[this.map.currentBasemap].layer);

			this.state.items.forEach((item)=>{
				if(!item.droppable) {
					if(item.data.defaultChecked){

						//read opacity from inut
						var input			= document.getElementById("checkbox_"+item.data.id);
						//item.data.opacity	= input.dataset.opacity;
						//when redrawing we stack layers below the last one.
						lastId = this.showInfoLayer(item.data, lastId);

					}
					else {
						this.hideInfoLayer(item.data);
					}
				}
			;
			});
			this.handleWorkMode(this.props.workMode);	
			this.ctx.tc.draw.drawCircles(this.ctx.tc.scenario);		
		});
	}
	undraw(lastState){
		var lastId;
		
		lastState.items.forEach((item)=>{
			if(!item.droppable) {
				if(item.data.defaultChecked){

					//read opacity from inut
					var input			= document.getElementById("checkbox_"+item.data.id);
					//item.data.opacity	= input.dataset.opacity;
					//when redrawing we stack layers below the last one.
					this.hideInfoLayer(item.data);

				}
				 
			}
		;
		});
		
		
	}
	handleWorkMode(wm){
		if(!wm || !wm.obj)
			return;
		wm.obj.infoLayerPanel = this;
		this.clearWorkMode();
		this.showWorkMode(wm);
	}
	showWorkMode(wm){
		if(wm && wm.extraLayers){

			wm.extraLayers.forEach((l)=>{
				this.showInfoLayer(l, null);
			});

		}
	}
	clearWorkMode(){
		wmConfig.workmodes.forEach((wm)=>{
			if(wm.extraLayers){

				wm.extraLayers.forEach((l)=>{
					this.hideInfoLayer(l);
				});

			}
		});
	}
	findClosestActiveLayer(res, info){
		
		
		var sIdx = this.findIdx(info.dragSourceId, res);

		for(var i = sIdx; i>=0; --i){
			if(res[i].droppable)
				continue;
			
			if(res[i].id != info.dragSourceId && res[i].data.defaultChecked){
				if(res[i].data.layerFn){
					const ids = this[res[i].data.layerFn]();
					return ids[ids.length-1].id;
				}
				return !Array.isArray(res[i].data.layer) ? res[i].data.layer.id : res[i].data.layer[res[i].data.layer.length-1].id;
			}
			
		}
		
		return false;
	}
	
	updateSectionName(name, id){
		
		var idx = this.findIdx(id);
		if(idx === false)
			return;
		
		var newItems = this.get();
		
		newItems[idx].text = name;
		newItems[idx].data.edit = false;
		
		this.updateStatus({items:newItems})
		
	}
	get(){
		return structuredClone(this.state.items);
	}
	getNode(id){
		
		var idx = this.findIdx(id);
		if(idx !== false)
			return this.state.items[idx];
		
		return false;
	}
	findIdx(id, items){
		var idx = items ? items.findIndex(i=>i.id == id) : this.state.items.findIndex(i=>i.id == id);
		if(idx > -1)
			return idx;
		return false;
	}
	findNextId(){
		var max = 0;
		this.state.items.forEach((i)=>{
			max = i.id > max ? i.id : max;
		});
		return ++max;
	}
	addSection(){
		
		const item = {
			id: this.findNextId(),
			parent:0,
			droppable: true,
			text: "New folder",
			data: {
				defaultOpen:false,
				edit: true
			}
		}
		var newItems = this.get();
		newItems.unshift(item);
		
		this.updateStatus({items:newItems});
		
	}
	addLayer(layer, idx, callBack){
		
		var n = [];
		if(!Array.isArray(layer))
			layer = [layer];
		
		layer.forEach((l)=>{
			n.push(this._addLayer(l));
		});
		
		
		if(!isNaN(idx)){
			
			n.forEach((i)=>{i.parent = this.state.items[idx].parent;});
			
			var newItems = this.get();
			
			Array.prototype.splice.apply(newItems, [...[idx+1, 0], ...n]);
		}
		else
			var newItems = [...n, ...this.get()];
		
		this.updateStatus({items:newItems}, (callBack ? ()=>{callBack(this.state.items);} : null));
		
		
	}
	_addLayer(layer){
		
		const sId = layer.type == 'raster' ? 'raster-'+layer.id : 'martin-'+layer.tablename+'-'+layer.id;
		const lId = layer.type == 'raster' ? 'raster-'+layer.id+'-layer' : layer.tablename+'-'+layer.id;
		
		if(this.findIdx(sId) !== false)
			return false;
		
		var item = {
			id: sId,
			parent:0,
			text: layer.name,
			data : {
				id: lId,
				vindrId: layer.id,
				defaultChecked: true,
				legend: layer.legend,
				source : {
					id: sId,
					type: layer.type ? layer.type : 'vector',
					/* tileSource er kilde-id-en til et ferdiggenerert PMTiles-arkiv
					   i Martin, satt i admin. Finnes den ikke, serveres laget fra
					   Postgres som før. Martin leverer begge som vanlige fliser,
					   så det eneste som skiller dem er navnet i URL-en.
					   source-layer nedenfor er fortsatt tablename: tippecanoe
					   kjøres med -l <tablename>, så laget inne i arkivet heter
					   det samme som tabellen. Se BESLUTNINGER 036. */
					tiles: [layer.type == 'raster' ? layer.url : getSourceUrl(layer.tileSource || layer.tablename, this.props.scenario.scenario_id)],
					/* tablename, ikke tileSource: denne brukes til oppslag mot
					   API-et (bbox, buffer), ikke til fliser. */
					tablename:layer.tablename,
					/* Rasterflisene er 256 px — både COG-serveren i API-et og
					   WMS-URL-ene (width=256&height=256). Mapbox antar 512 om
					   ingenting sies, og tegner dem da på halv oppløsning. */
					...(layer.type == 'raster' ? {tileSize: 256} : {}),
				},
				layer:[
					{
						'id': lId,
						/* Lagtypen følger datasettets type, ikke vectorType. Et
						   rasterlag har også en vectorType i basen (den settes til
						   'fill' når laget opprettes), og å lese den her ga et
						   fill-lag på en rasterkilde — Mapbox avviser det, så laget
						   ble aldri lagt til og ingen fliser ble hentet. */
						'type': layer.type == 'raster' ? 'raster' : (layer.vectorType || 'fill'),
						'source': sId,
						'paint': layer.paint,
						'layout': layer.layout
					},
				]
			}
		}
		
		/* Zoomvindu fra laginnstillingene (settes i admin). Paa kilden, ikke paa
		   laget: da ber MapLibre aldri om fliser utenfor vinduet — samme
		   oppforsel som minzoom/maxzoom i Martins gamle config-fil ga. Over
		   maxzoom gjenbrukes siste flisniva, slik at laget ikke forsvinner. */
		if(Number.isInteger(layer.minZoom))
			item.data.source.minzoom = layer.minZoom;

		/* To ulike grenser moetes her. layer.maxZoom er brukerens
		   visningsvindu; layer.tileMaxZoom er hvor hoeyt PMTiles-arkivet
		   faktisk rekker. Settes ikke arkivets grense, ber MapLibre om fliser
		   som ikke finnes, Martin svarer 204, og laget forsvinner naar man
		   zoomer forbi siste niva i stedet for aa overzoome det.
		   Er begge satt, er den laveste den bindende. */
		const zoomCaps = [layer.maxZoom, layer.tileSource ? layer.tileMaxZoom : null]
			.filter(z => Number.isInteger(z));
		if(zoomCaps.length)
			item.data.source.maxzoom = Math.min(...zoomCaps);
		
		if( (layer.label !== null) && (typeof layer.label === "object" || typeof layer.label === 'function') && Object.keys(layer.label).length !== 0 ){
			const a = {
				'id': lId+'-text',
				'type': 'symbol',
				'source': sId,
				'source-layer': layer.tablename,
				'paint': layer.label.paint,
				'layout': layer.label.layout
			}
			item.data.layer.push(a);
			
		}
		
		if(Array.isArray(layer.filter)){
			item.data.layer.forEach((l)=>{
				l["filter"] = layer.filter;
			});
		}
		
		if(layer.type != 'raster')
			item.data['layer'][0]['source-layer'] =	layer.tablename;
		else if(layer.cogFile)
			/* COG-lagene er klassifiserte rasterkart med store celler. Standarden
			   'linear' interpolerer mellom cellene og smører fargene ut; QGIS
			   tegner de samme dataene skarpt med nærmeste nabo. Gjelder bare
			   COG-er — en WMS-tjeneste leverer ferdig tegnede kartbilder der
			   den mykere skaleringen er riktig. */
			item.data['layer'][0]['paint'] = {'raster-resampling': 'nearest'};
		else
			delete item.data['layer'][0]['paint'];
		
		this.showInfoLayer(item.data, null);
		return item;
	}
	remLayer(layer){
		
		var idx = this.state.items.findIndex((a)=>{return a.data.vindrId == layer.id});
		
		if(idx != -1)
			this.deleteItem(this.state.items[idx]);
		
	}
	handleZoomToFit(item){
		
		atlasApi.getBoundingBox(item.data.vindrId).then((results)=>{
			
			if(results && results.coordinates){
				this.map.fitBounds([results.coordinates[0][0], results.coordinates[0][2]]);
			}
			
		});
		
	}
	
	/* Attributtabellen under kartet. Tabellnavnet er source-layer paa laget —
	   det samme navnet som tabellen har i uploads-skjemaet. */
	handleOpenTable(node){

		const layers = Array.isArray(node.data.layer) ? node.data.layer : [node.data.layer];
		const table = layers[0]['source-layer'];

		if(!table)
			return;

		/* Aapner man tabellen for et annet lag, ville det forrige lagets filter
		   blitt staaende paa kartet uten et panel som forklarer det. */
		if(this.state.tablePanel)
			this.restoreLayerFilter(this.state.tablePanel);

		/* Lagets eget filter (satt i laginnstillingene) skal overleve at
		   brukeren filtrerer i panelet, saa det tas vare paa her og legges
		   sammen med panelets filter naar det settes. */
		const original = {};

		layers.forEach((l)=>{
			if(this.map.getLayer(l.id))
				original[l.id] = this.map.getFilter(l.id) || null;
		});

		this.updateStatus({tablePanel: {
			id: node.data.id,
			table: table,
			name: node.text,
			color: layerSwatchColor(layers),
			layerIds: layers.map((l)=>l.id),
			original: original
		}});
	}
	closeTablePanel(){

		if(this.state.tablePanel)
			this.restoreLayerFilter(this.state.tablePanel);

		this.updateStatus({tablePanel: null});
	}
	restoreLayerFilter(panel){

		panel.layerIds.forEach((id)=>{
			if(this.map.getLayer(id))
				this.map.setFilter(id, panel.original[id] || null);
		});
	}
	applyLayerFilter(panel, filters, columns){

		if(!panel)
			return;

		if(!filters.length)
			return this.restoreLayerFilter(panel);

		const uttrykk = layerFilterExpression(filters, columns);

		panel.layerIds.forEach((id)=>{

			if(!this.map.getLayer(id))
				return;

			const original = panel.original[id];

			this.map.setFilter(id, original ? ['all', original, uttrykk] : uttrykk);
		});
	}
	uploadLayer(){
		

	}
	hideDialog(){
		this.updateStatus({dialog:{open:false}});
	}
	hideDialogUpload(){
		this.updateStatus({dialogUpload:{open:false}});
	}
	showDialog(){
		this.updateStatus({dialog:{open:true}});
	}
	showDialogUpload(){
		this.updateStatus({dialogUpload:{open:true}});
	}
	handleMakeBuffer(row, e){
		
		this.e = e;
		
		var idx = this.findIdx(row.id, this.state.items);
		
		this.updateStatus({dialogBuffer:{open:true, layer:row, idx: idx}});
	}
	hideDialogBuffer = (callback)=>{
		this.updateStatus({dialogBuffer:{open:false}}, callback);
	}
	handleOnBuffer = (layer,  idx) => {
		
		this.addLayer(layer,  idx, ()=>{
			
			this.hideDialogBuffer(()=>{
				this.onOpacity(new Event("click"), this.state.items[idx+1]);
			});
		
		});
		
	}
	handleItemClick(e){
		//contextMenu.hideAll();
	}
	closeContextMenu(e){
		contextMenu.hideAll();
	}
	toggleSubMenu(e){
		e.preventDefault();

		let parent = document.querySelector("#project-layers");
		parent.classList.toggle('show');
		e.target.classList.toggle('show');

			//this.props.onUpdateSize();
	}
	handleDownload(layer){
		
		var filePromises = [atlasApi.downloadLibLayer(layer.data.vindrId)];
		const zip = new JSZip();
		
		Promise.all(filePromises).then((results)=>{
			results.forEach((f,k)=>{

				fs.saveAs(f, filenamify(layer.text)+'.gpkg');
				
			});

			
		});
	}
	handleUpload(){
		
		if(this.libraryDialog.current)
			this.libraryDialog.current.handleOnShow({});
		
	}
	handleAddProjectLayer = (layer, project) => {
		
		atlasApi.addProjectLayer(layer.data.vindrId, project.projectid).then((res)=>{
			if(res.id)
				this.ctx.QN.current.show("Layer "+layer.text + " was added to " + project.name + " library");
			else
				this.ctx.QN.current.show("An error has occurred");
		});
		
		
	}
	render() {
		return (
			<>
				{/*
				<Row className="align-items-center project-layers">
							
					<Col xs="2">
						<StackSimple size={16} />
					</Col>
					<Col xs="10" className="ps-0">
						<div onClick={(e)=>this.toggleSubMenu(e)} className="nav-link has-sub show"><span>Layers</span></div>
					</Col>

					
				</Row>
				*/}
				<div id="project-layers" className="nav-item show">
							
							
					<div className="layer-tree">
							<DndProvider backend={MultiBackend} options={getBackendOptions()}>
								<Tree
									tree={this.state.items}
									rootId={0}
									render={(node, { depth, isOpen, onToggle }) => {
										if(node.id == 'ellipses')
											return '';
										
										return (


											<div 
												className={
													(node.droppable ? 'item-folder':'item-layer') + 
													' ' + 
													(!!this.state.selectedItems.find((n) => n.id === node.id) ? 'selected':'')
													+ (node.data.passive ? ' passive ' : '')
												} 
												style={{ marginInlineStart: depth * 3 }}  




												title={node.data.defaultChecked ? 'Right click for options' : ''}
											>
												{node.droppable && (
													<>
														{node.data.defaultOpen ? <Folder  onClick={(e, b)=>{e.stopPropagation(); this.handleFolderToggle(node.id); onToggle.call(e);}} size={14} /> : <FolderOpen className="folder"  onClick={(e, b)=>{e.stopPropagation(); this.handleFolderToggle(node.id); onToggle.call(e);}} size={14} />}

														<EditNow id={node.id}  onClick={(e, b)=>{e.stopPropagation(); this.handleFolderToggle(node.id); onToggle.call(e);}} edit={node.data.edit} value={node.text} editable={true} onUpdate={(val)=>{this.updateSectionName(val, node.id)}} />


														<Dropdown>
															<Dropdown.Toggle variant="default">
																<i className="ri-more-2-fill"></i>
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item href="#" onClick={(e)=>{document.getElementById('edit-static-'+node.id).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))}} className="details"><PencilSimple size={12} className="me-2" /> Rename</Dropdown.Item>
																<Dropdown.Item href="#" onClick={(e)=>{e.stopPropagation();this.deleteItem(node);}} className="details text-danger"><i className="ri-delete-bin-line me-2"></i> Delete</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>	
													</>
												)}
												{!node.droppable && (
													<>
														<DotsSixVertical className="handle" size={8} />
														<EditNow id={node.id} value={node.text} editable={true} onUpdate={(val)=>{this.updateSectionName(val, node.id)}} />
														<Form.Check  type="switch"
															id={"checkbox_"+node.data.id} 
															value={node.data.id} 
															data-layer={node.data.layer.map((l)=>{return l.id}).join(",")} 
															onClick={(e)=>{this.onLayerToggle(e, node.id);}} 
															defaultChecked={node.data.defaultChecked ? "checked" : ""} 
															data-opacity={node.data.opacity != 'undefined' ? node.data.opacity : 1} 
														/>

														{/*<span className="position-absolute top-50 start-0 translate-middle p-1  border-light rounded-circle"  style={{backgroundColor:this.getLayerColor(node)}}></span>*/}

														{(!node.data.passive || node.data.id == 'properties') &&	
														<Dropdown className="minimal">
															<Dropdown.Toggle variant="default">
																<i className="ri-more-2-fill"></i>
															</Dropdown.Toggle>
															<Dropdown.Menu>

																<Dropdown.Item href="#" onClick={(e)=>{this.onOpacity(e, node);}} className="important"><Palette weight="bold" size={16} /> Styling</Dropdown.Item>
																{node.data.id != 'properties' &&
																	<>
																		{!!node.data.vindrId && !!this.props.project &&
																			<Dropdown.Item href="#" onClick={(e)=>{this.handleAddProjectLayer(node, this.props.project)}}><Book weight="bold" size={16} /> Add to {this.props.project.name} library</Dropdown.Item>
																		}
																		<Dropdown.Item href="#" onClick={(e)=>{document.getElementById('edit-static-'+node.id).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))}}><PencilSimple weight="bold" size={16} /> Rename</Dropdown.Item>
																		{!!node.data.layer.length && node.data.layer[0].type != 'raster' &&
																		<>
																			<Dropdown.Item href="#" onClick={(e)=>{this.handleMakeBuffer(node, e)}}><CircleHalf weight="bold" size={16} /> Buffer</Dropdown.Item>
																			<Dropdown.Item href="#" onClick={(e)=>{this.handleZoomToFit(node)}}><Crosshair weight="bold" size={16} /> Zoom to fit</Dropdown.Item>
																			{!!node.data.layer[0]['source-layer'] &&
																				<Dropdown.Item href="#" onClick={(e)=>{this.handleOpenTable(node)}}><Table weight="bold" size={16} /> Attribute table</Dropdown.Item>
																			}
																			<Dropdown.Item href="#" onClick={(e)=>{this.handleDownload(node)}}><DownloadSimple weight="bold" size={16} /> Download</Dropdown.Item>
																		</>
																		}

																		<Dropdown.Item href="#" onClick={(e)=>{e.stopPropagation();this.deleteItem(node);this.libraryDialog.current.remInUse(node.data.id)}} className="details text-danger"><Trash weight="bold" size={16} /> Remove</Dropdown.Item>
																	</>
																}
															</Dropdown.Menu>
														</Dropdown>
														}
														{this.toolMenu(node)}

														{(!!this.toolMenu(node)) || (node.data.passive && node.data.id != 'properties') &&
															<span className="spacer"></span>
														}


													</>
												)}
											</div>
										)
									}}

									sort={false}
									insertDroppableFirst={false}
									canDrop={(tree, { dragSourceId, dropTargetId, dragSource, dropTarget }) => {
										
										if(dragSource?.droppable && dropTarget?.droppable)
											return false;
											
										if (dragSource?.parent === dropTargetId) {
											return true;
										}
									}}
									dragPreviewRender={(monitorProps) => { return (
										<div className="item-layer-preview" style={{width:monitorProps.item.ref.current.clientWidth}}>
											<DotsSixVertical size={8} />
											{monitorProps.item.text}
											<Form.Check  type="switch" id={"checkbox_preview"} defaultChecked={monitorProps.item.data.defaultChecked ? "checked" : ""} />
											<i className="ri-more-2-fill"></i>
										</div>
									)}}
									enableAnimateExpand = {true}
									onDragEnd = {(a, b, c)=>{}}
									onDrop={(data, { dragSourceId, dropTargetId, dragSource, dropTarget })=>{this.reorderLayer(data,{ dragSourceId, dropTargetId, dragSource, dropTarget });}}
									dropTargetOffset={5} 
									placeholderRender={(node, { depth }) => (

										<div className="item-placeholder"></div>
									)}
									classes={{
										dropTarget: "item-drag-over"
									}}
									initialOpen={(this.state.items.filter((i)=>!i.data.defaultOpen)).map((l)=>l.id)}

								/>
							</DndProvider>
						</div>				
							
							
				</div>
				<Row className="align-items-center layer-options">
							
					
					<Col xs="12">
						<a onClick={(e)=>{this.showDialog();}} ><PlusCircle size={15} /> Add layer from library...</a>
					</Col>
					<Col xs="12">
						<a onClick={(e)=>{this.showDialogUpload()}}><UploadSimple size={15} /> Upload layer...</a>
					</Col>
					<Col xs="12">
						<a onClick={(e)=>{this.addSection()}}><FolderSimplePlus size={15} /> Add folder...</a>
					</Col>

					
				</Row>
				
			
			<Menu id="layer_style_control">
				<Item closeOnClick={false} onClick={(e)=>this.handleItemClick(e)}>
					<LayerStylePanel 
						ref={this.layerStylePanel}
						onOpacityChange={(data)=>{this.handleOpacityChange(data);}}
						onPaintChange={(paintProp, code)=>{this.handlePaintChange(code, paintProp);}}
						layer={this.state.contextLayer}
						onClose={(e)=>{this.closeContextMenu(e);}}
					/>
				</Item>
			</Menu>
			
			<DialogLayerLibrary ref={this.libraryDialog} setup={this.state.dialog} user={this.props.user} onUpload={(e)=>{this.showDialogUpload(e);}} project={this.props.project} inUse={this.state.items} onSelect={(layer)=>{this.addLayer(layer);}} onDeSelect={(layer)=>{this.remLayer(layer);}} onClose={()=>{this.hideDialog();}} />
			<DialogBuffer setup={this.state.dialogBuffer} map={this.map} user={this.props.user} onBuffer={this.handleOnBuffer} onClose={this.hideDialogBuffer} />
			<DialogUploadLayer setup={this.state.dialogUpload} user={this.props.user} country={this.props.project ? this.props.project.country : ''} onUpload={(layer)=>{this.addLayer(layer);}} onClose={()=>{this.hideDialogUpload(); this.handleUpload();}} />
			
			{/* Panelet hoerer visuelt til kartet, ikke til lagpanelet det aapnes
			    fra, saa det portaleres ut i DOM-en ved siden av kartet.

			    Forelderen, ikke kartcontaineren selv: .project-map har
			    position:absolute og z-index:1, og det er en egen
			    stacking-kontekst. Alt inne i den er laast til nivaa 1, saa
			    basiskart-velgeren (.layer-panel, soesken paa nivaa 10) ville
			    tegnet seg oppaa panelet uansett hvilken z-index panelet fikk.
			    Som soesken vinner panelets 60 over dens 10.

			    Geometrien blir den samme: .project-map er inset:0 i den samme
			    forelderen, saa bottom/left/right:0 treffer kartets kanter. */}
			{!!this.state.tablePanel && this.map && ReactDOM.createPortal(
				<LayerTablePanel
					key={this.state.tablePanel.id}
					layer={this.state.tablePanel}
					projectId={this.props.project ? this.props.project.id : null}
					onFilterChange={(filters, columns)=>{this.applyLayerFilter(this.state.tablePanel, filters, columns);}}
					onClose={()=>{this.closeTablePanel();}}
				/>,
				this.map.getContainer().parentElement || this.map.getContainer()
			)}
			
		</>
		);
	}
}

export default InfoLayers;